<template>
  <div>
    <ejs-textbox
      placeholder="Enter..."
      :multiline="true"
      @change="onChange($event.value)"
      :value="data.answerAdditionalInformation"
      :maxlength="250"
      :rows="5"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      data: {},
    };
  },
  computed: {
    ...mapGetters({
      applicationWorkLists: 'applicationWorkLists',
    }),
  },
  methods: {
    onChange(val) {
      this.applicationWorkLists.find(
        (x) => x.workListId == this.data.workListId,
      ).answerAdditionalInformation = val;
    },
  },
};
</script>
